'use strict'
import React from 'react'
import PropTypes from 'prop-types'
import { withCookies, Cookies } from 'react-cookie'

class Experiment extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      variantIndex: [0],
      isMounted: false
    }
  }

  getChildContext () {
    return {
      getExperimentName: this.props.name,
      getValidVariants: this.props.variants
    }
  }

  render () {
    const { children } = this.props
    const Wrapper = this.props.childrenWrapper
    const { renderOnServer } = this.context.labConfig

    if (renderOnServer) {
      return (
        <Wrapper>{children}</Wrapper>
      )
    }

    if (this.state.isMounted || !this.getFlickerContext()) {
      let customChildren
      customChildren = React.Children.map(this.props.children, (child, i) => {
        if (this.state.variantIndex.includes(i)) {
          return child
        }
      })

      return (
        this.getRenderData(customChildren)
      )
    }

    if (this.props.children && this.props.children.length > 0) {
      const children = this.getChildren()
      return (
        <Wrapper>
          {children}
          {this.showChosenVariant()}
        </Wrapper>)
    }

    return ''
  }

  getRenderData (toRender) {
    return !this.props.renderInline ? <div>{toRender}</div> : <span>{toRender}</span>
  }

  getFlickerContext () {
    if (!this.context || !this.context.labConfig) {
      return false
    }

    return this.context.labConfig.dangerousNonFlicker
  }

  showChosenVariant () {
    return (
      <script type='text/javascript' dangerouslySetInnerHTML={{__html: `
        window.selectVariants('${this.props.name}')
      `}} />
    )
  }

  getChildren () {
    const children = React.Children.map(this.props.children, (child, index) => {
      if (child.props.type !== 'variant') return child

      const style = index === 0 ? 'visible' : 'hidden'
      return <div className={`variant-${this.props.name.toLowerCase()} variant-${child.props.name.toLowerCase()} ${style}`}>{child}</div>
    })

    return children
  }

  componentDidMount () {
    if (!global.window) return null
    const { cookies } = this.props
    const variantName = cookies.get(this.props.name)

    if (!variantName || !this.props.children) return null

    let variantIndicies

    variantIndicies = React.Children.map(this.props.children, (variant, i) => {
      if (!!variant.props && !!variant.props.type && variant.props.type === 'variant') {
        if (variant.props.name.toLowerCase() === variantName.toLowerCase()) {
          return i
        }
      } else {
        return i
      }
    })

    if (!variantIndicies || variantIndicies.length < 1) {
      variantIndicies = [0]
    }

    this.setState({
      variantIndex: variantIndicies,
      isMounted: true
    })
  }
}

Experiment.childContextTypes = {
  getExperimentName: PropTypes.string,
  getValidVariants: PropTypes.array
}

Experiment.contextTypes = {
  labConfig: PropTypes.object
}

Experiment.defaultProps = {
  childrenWrapper: 'div',
  variants: [],
  renderInline: false
}

Experiment.propTypes = {
  name: PropTypes.string.isRequired,
  variants: PropTypes.array.isRequired,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  childrenWrapper: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  renderInline: PropTypes.bool
}

export default withCookies(Experiment)
